import { useEffect } from 'react'
import { useNavigate } from 'react-router'

/** Старый URL /discount/services/create → список со карточками акций снизу */
function CreatePromoWizard() {
	const navigate = useNavigate()

	useEffect(() => {
		navigate('/discount/services', { replace: true })
	}, [navigate])

	return null
}

export default CreatePromoWizard
